/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GenerateImageDto,
  ImageGenerationStartDto,
  ImageGenerationStatusDto,
  ImagesControllerGetLibrary200,
  ImagesControllerGetLibraryParams,
  SetImageFromAssetDto,
  SetImageFromGeneratedDto,
  SetProfileImageFromAssetDto,
  SetProfileImageFromGeneratedDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List image library
 */
export const imagesControllerGetLibrary = (
  params: ImagesControllerGetLibraryParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ImagesControllerGetLibrary200>(
    { url: `/images/library`, method: "GET", params, signal },
    options,
  );
};

export const getImagesControllerGetLibraryQueryKey = (
  params?: ImagesControllerGetLibraryParams,
) => {
  return [`/images/library`, ...(params ? [params] : [])] as const;
};

export const getImagesControllerGetLibraryQueryOptions = <
  TData = Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  params: ImagesControllerGetLibraryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getImagesControllerGetLibraryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof imagesControllerGetLibrary>>
  > = ({ signal }) =>
    imagesControllerGetLibrary(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ImagesControllerGetLibraryQueryResult = NonNullable<
  Awaited<ReturnType<typeof imagesControllerGetLibrary>>
>;
export type ImagesControllerGetLibraryQueryError = ErrorType<unknown>;

export function useImagesControllerGetLibrary<
  TData = Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  params: ImagesControllerGetLibraryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
          TError,
          Awaited<ReturnType<typeof imagesControllerGetLibrary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useImagesControllerGetLibrary<
  TData = Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  params: ImagesControllerGetLibraryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
          TError,
          Awaited<ReturnType<typeof imagesControllerGetLibrary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useImagesControllerGetLibrary<
  TData = Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  params: ImagesControllerGetLibraryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List image library
 */

export function useImagesControllerGetLibrary<
  TData = Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
  TError = ErrorType<unknown>,
>(
  params: ImagesControllerGetLibraryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetLibrary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getImagesControllerGetLibraryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const imagesControllerStartGenerateImage = (
  generateImageDto: BodyType<GenerateImageDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ImageGenerationStartDto>(
    {
      url: `/images/generate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateImageDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerStartGenerateImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>,
    TError,
    { data: BodyType<GenerateImageDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>,
  TError,
  { data: BodyType<GenerateImageDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerStartGenerateImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>,
    { data: BodyType<GenerateImageDto> }
  > = (props) => {
    const { data } = props ?? {};

    return imagesControllerStartGenerateImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerStartGenerateImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>
>;
export type ImagesControllerStartGenerateImageMutationBody =
  BodyType<GenerateImageDto>;
export type ImagesControllerStartGenerateImageMutationError =
  ErrorType<unknown>;

export const useImagesControllerStartGenerateImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>,
      TError,
      { data: BodyType<GenerateImageDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerStartGenerateImage>>,
  TError,
  { data: BodyType<GenerateImageDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerStartGenerateImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerGetGenerateImageStatus = (
  jobId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ImageGenerationStatusDto>(
    { url: `/images/generate/status/${jobId}`, method: "GET", signal },
    options,
  );
};

export const getImagesControllerGetGenerateImageStatusQueryKey = (
  jobId?: string,
) => {
  return [`/images/generate/status/${jobId}`] as const;
};

export const getImagesControllerGetGenerateImageStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getImagesControllerGetGenerateImageStatusQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>
  > = ({ signal }) =>
    imagesControllerGetGenerateImageStatus(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ImagesControllerGetGenerateImageStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>
>;
export type ImagesControllerGetGenerateImageStatusQueryError =
  ErrorType<unknown>;

export function useImagesControllerGetGenerateImageStatus<
  TData = Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
          TError,
          Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useImagesControllerGetGenerateImageStatus<
  TData = Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
          TError,
          Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useImagesControllerGetGenerateImageStatus<
  TData = Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useImagesControllerGetGenerateImageStatus<
  TData = Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
  TError = ErrorType<unknown>,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof imagesControllerGetGenerateImageStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getImagesControllerGetGenerateImageStatusQueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const imagesControllerSetTrackArtworkFromAsset = (
  trackId: string,
  setImageFromAssetDto: BodyType<SetImageFromAssetDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/track/${trackId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setImageFromAssetDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetTrackArtworkFromAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>,
    TError,
    { trackId: string; data: BodyType<SetImageFromAssetDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>,
  TError,
  { trackId: string; data: BodyType<SetImageFromAssetDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerSetTrackArtworkFromAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>,
    { trackId: string; data: BodyType<SetImageFromAssetDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return imagesControllerSetTrackArtworkFromAsset(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerSetTrackArtworkFromAssetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>
  >;
export type ImagesControllerSetTrackArtworkFromAssetMutationBody =
  BodyType<SetImageFromAssetDto>;
export type ImagesControllerSetTrackArtworkFromAssetMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetTrackArtworkFromAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>,
      TError,
      { trackId: string; data: BodyType<SetImageFromAssetDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromAsset>>,
  TError,
  { trackId: string; data: BodyType<SetImageFromAssetDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetTrackArtworkFromAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerSetAlbumArtworkFromAsset = (
  albumId: string,
  setImageFromAssetDto: BodyType<SetImageFromAssetDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/album/${albumId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setImageFromAssetDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetAlbumArtworkFromAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>,
    TError,
    { albumId: string; data: BodyType<SetImageFromAssetDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>,
  TError,
  { albumId: string; data: BodyType<SetImageFromAssetDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerSetAlbumArtworkFromAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>,
    { albumId: string; data: BodyType<SetImageFromAssetDto> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return imagesControllerSetAlbumArtworkFromAsset(
      albumId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerSetAlbumArtworkFromAssetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>
  >;
export type ImagesControllerSetAlbumArtworkFromAssetMutationBody =
  BodyType<SetImageFromAssetDto>;
export type ImagesControllerSetAlbumArtworkFromAssetMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetAlbumArtworkFromAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>,
      TError,
      { albumId: string; data: BodyType<SetImageFromAssetDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromAsset>>,
  TError,
  { albumId: string; data: BodyType<SetImageFromAssetDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetAlbumArtworkFromAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerSetTrackArtworkFromGenerated = (
  trackId: string,
  setImageFromGeneratedDto: BodyType<SetImageFromGeneratedDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/track/${trackId}/generated`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setImageFromGeneratedDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetTrackArtworkFromGeneratedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>,
    TError,
    { trackId: string; data: BodyType<SetImageFromGeneratedDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>,
  TError,
  { trackId: string; data: BodyType<SetImageFromGeneratedDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerSetTrackArtworkFromGenerated"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>,
    { trackId: string; data: BodyType<SetImageFromGeneratedDto> }
  > = (props) => {
    const { trackId, data } = props ?? {};

    return imagesControllerSetTrackArtworkFromGenerated(
      trackId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerSetTrackArtworkFromGeneratedMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>
  >;
export type ImagesControllerSetTrackArtworkFromGeneratedMutationBody =
  BodyType<SetImageFromGeneratedDto>;
export type ImagesControllerSetTrackArtworkFromGeneratedMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetTrackArtworkFromGenerated = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>,
      TError,
      { trackId: string; data: BodyType<SetImageFromGeneratedDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetTrackArtworkFromGenerated>>,
  TError,
  { trackId: string; data: BodyType<SetImageFromGeneratedDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetTrackArtworkFromGeneratedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerSetAlbumArtworkFromGenerated = (
  albumId: string,
  setImageFromGeneratedDto: BodyType<SetImageFromGeneratedDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/album/${albumId}/generated`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setImageFromGeneratedDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetAlbumArtworkFromGeneratedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>,
    TError,
    { albumId: string; data: BodyType<SetImageFromGeneratedDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>,
  TError,
  { albumId: string; data: BodyType<SetImageFromGeneratedDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerSetAlbumArtworkFromGenerated"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>,
    { albumId: string; data: BodyType<SetImageFromGeneratedDto> }
  > = (props) => {
    const { albumId, data } = props ?? {};

    return imagesControllerSetAlbumArtworkFromGenerated(
      albumId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerSetAlbumArtworkFromGeneratedMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>
  >;
export type ImagesControllerSetAlbumArtworkFromGeneratedMutationBody =
  BodyType<SetImageFromGeneratedDto>;
export type ImagesControllerSetAlbumArtworkFromGeneratedMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetAlbumArtworkFromGenerated = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>,
      TError,
      { albumId: string; data: BodyType<SetImageFromGeneratedDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetAlbumArtworkFromGenerated>>,
  TError,
  { albumId: string; data: BodyType<SetImageFromGeneratedDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetAlbumArtworkFromGeneratedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerSetProfilePictureFromAsset = (
  creatorId: string,
  setProfileImageFromAssetDto: BodyType<SetProfileImageFromAssetDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/profile/${creatorId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setProfileImageFromAssetDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetProfilePictureFromAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>,
    TError,
    { creatorId: string; data: BodyType<SetProfileImageFromAssetDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>,
  TError,
  { creatorId: string; data: BodyType<SetProfileImageFromAssetDto> },
  TContext
> => {
  const mutationKey = ["imagesControllerSetProfilePictureFromAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>,
    { creatorId: string; data: BodyType<SetProfileImageFromAssetDto> }
  > = (props) => {
    const { creatorId, data } = props ?? {};

    return imagesControllerSetProfilePictureFromAsset(
      creatorId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ImagesControllerSetProfilePictureFromAssetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>
  >;
export type ImagesControllerSetProfilePictureFromAssetMutationBody =
  BodyType<SetProfileImageFromAssetDto>;
export type ImagesControllerSetProfilePictureFromAssetMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetProfilePictureFromAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>,
      TError,
      { creatorId: string; data: BodyType<SetProfileImageFromAssetDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromAsset>>,
  TError,
  { creatorId: string; data: BodyType<SetProfileImageFromAssetDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetProfilePictureFromAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const imagesControllerSetProfilePictureFromGenerated = (
  creatorId: string,
  setProfileImageFromGeneratedDto: BodyType<SetProfileImageFromGeneratedDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/images/profile/${creatorId}/generated`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setProfileImageFromGeneratedDto,
      signal,
    },
    options,
  );
};

export const getImagesControllerSetProfilePictureFromGeneratedMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>
      >,
      TError,
      { creatorId: string; data: BodyType<SetProfileImageFromGeneratedDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>>,
    TError,
    { creatorId: string; data: BodyType<SetProfileImageFromGeneratedDto> },
    TContext
  > => {
    const mutationKey = ["imagesControllerSetProfilePictureFromGenerated"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>
      >,
      { creatorId: string; data: BodyType<SetProfileImageFromGeneratedDto> }
    > = (props) => {
      const { creatorId, data } = props ?? {};

      return imagesControllerSetProfilePictureFromGenerated(
        creatorId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ImagesControllerSetProfilePictureFromGeneratedMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>>
  >;
export type ImagesControllerSetProfilePictureFromGeneratedMutationBody =
  BodyType<SetProfileImageFromGeneratedDto>;
export type ImagesControllerSetProfilePictureFromGeneratedMutationError =
  ErrorType<unknown>;

export const useImagesControllerSetProfilePictureFromGenerated = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>
      >,
      TError,
      { creatorId: string; data: BodyType<SetProfileImageFromGeneratedDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof imagesControllerSetProfilePictureFromGenerated>>,
  TError,
  { creatorId: string; data: BodyType<SetProfileImageFromGeneratedDto> },
  TContext
> => {
  const mutationOptions =
    getImagesControllerSetProfilePictureFromGeneratedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
